import { gql } from "@apollo/client";

const SEARCH_LISTINGS = gql`
  query Event($term: String) {
    newSearch(term: $term) {
      event {
        name
        subCategory {
          name
        }
        images
        id
      }
    }
  }
`;

const GET_GEOREGIONS = gql`
  query GeoRegions {
    geoRegions {
      county
      id
    }
  }
`;

const GET_CATEGORIES = gql`
  query Categories {
    categories {
      id
      name
      subcategories {
        id
        name
      }
    }
  }
`;

const GET_EVENT_LIST = gql`
  query Events($geoRegionCounty: String, $categoryId: ID) {
    events(geoRegionCounty: $geoRegionCounty, categoryId: $categoryId) {
      general {
        id
        name
        images
        startDate
        endDate
        isPublished
        mainEventCountyVisibility
        openingHours
        subCategory {
          id
          name
        }
        category {
          id
          name
        }
        startPrice
        currency
      }
      address {
        venueName
        street
        city
        googleLocationLink
      }
      rating {
        bookLink
        priceRangeEnd
        priceRangeStart
        program
        rating
        reviewsCount
      }
      tickets {
        ticketTypes {
          price
        }
      }
    }
  }
`;

const GET_LOCATION_VENUE_EVENTS = gql(`
query Events($locationVenueId: ID) {
  events(locationVenueId: $locationVenueId) {
    general {
        id
        name
        images
        startDate
        endDate
        isPublished
        mainEventCountyVisibility
        openingHours
        status
        subCategory {
          id
          name
        }
        category {
          id
          name
        }
        startPrice
        currency
      }
      address {
        venueName
        street
        city
        googleLocationLink
      }
      rating {
        bookLink
        priceRangeEnd
        priceRangeStart
        program
        rating
        reviewsCount
      }
      tickets {
        ticketTypes {
          price
        }
      }
  }
}
`);

const GET_MAIN_EVENT_LIST = gql`
  query Trending($geoRegionCounty: String, $categoryId: String) {
    trending(geoRegionCounty: $geoRegionCounty, categoryId: $categoryId) {
      general {
        id
        images
        name
        startDate
        endDate
        isPublished
        mainEventCountyVisibility
        openingHours
        subCategory {
          id
          name
        }
        category {
          id
          name
        }
        fields
        startPrice
        currency
      }
      address {
        venueName
        street
        city
        googleLocationLink
      }
      rating {
        bookLink
        priceRangeEnd
        priceRangeStart
        program
        rating
        reviewsCount
      }
    }
  }
`;

const GET_EVENT = gql`
  query Event($eventId: ID!) {
    event(id: $eventId) {
      general {
        id
        images
        name
        description
        organizerEmail
        organizerPhone
        twilioPhone
        organizerWebsite
        isPublished
        status
        fields
        organizerDisplayName
        company {
          enabledStripe
          avatar
        }
        startDate
        endDate
        subCategory {
          name
          id
        }
        category {
          id
          name
        }
        tags {
          id
          name
        }
        visibility
        isPermanent
        isRecurring
        isSeasonPassSale
        openingHours
        seatsIoEventKey
        currency
        commissionPaidByUser
        linkedEvents {
          general {
            id
            name
            startDate
            endDate
            images
            subCategory {
              name
              id
            }
          }
          booking {
            moduleStatus
          }
          tickets {
            moduleStatus
          }
        }
        permanentVenue {
          general {
            id
            images
            name
            startDate
            endDate
            currency
            isRecurring
          }
          booking {
            id
            moduleStatus
            moduleStatusBookingMenu
            enabledCustomerPlan
            isBookableUnit
            maxGuests
            minGuests
            maxBookingGuests
            minBookingGuests
          }
          tickets {
            moduleStatus
          }
        }
      }
      address {
        venueName
        street
        city
        county
        googleLocationLink
      }
      tickets {
        ticketTypes {
          price
          id
          name
          available
          ticketOrder
          total
          isPublished
          series
          sellEndDate
          sellStartDate
          order
          description
          seatingChartCategories { id }
          category {
            name
          }
          ticketSubcategory {
            name
          }
          promotionType
          promotionMetadata
          event {
            general {
              commissionPaidByUser
            }
            tickets {
              comission
            }
          }
        }
        borderColor
        ticketImage
        comission
        maxCartTicketQuantity
        showRemainingTickets
        entryType
        moduleStatus
      }
      rating {
        bookLink
        priceRangeEnd
        priceRangeStart
        program
        rating
        reviewsCount
      }
      marketing {
        emailSubtitleCancelled
        emailSubtitlePending
        emailSubtitleApproved
        emailSubtitleWaitlist
        emailSubtitleTickets
      }
      booking {
        areas {
          id
          name
          price
          description
        }
        id
        bookingInterval
        bookingDuration
        automaticConfirmation
        enabledCustomerPlan
        enabledMenuPurchase
        enabledSpecialRequirements
        enabledHoldingFeePerPerson
        enabledCheckAvailability
        enabledWaitlist
        enabledReminder
        reminderThresholdHours
        noActionThresholdHours
        enabledReconfirmation
        isBookableUnit
        maxGuests
        minGuests
        maxBookingGuests
        minBookingGuests        
        holdingFee
        moduleStatus
        moduleStatusBookingMenu
        comissionHoldingFee
        menus {
            id
            name
            description
            category
            price
            quantity
            quantityMetric
        }
        specialOccasions {
          id
          name
        }
        dietaryRestrictions {
          id
          name
        }
        tableRequirements {
          id
          name
        }
        clientTags {
          id
          name
        }  
      }
      chartEvent { id chartId holdTtlMinutes }
      questionnaire {
        id
        moduleStatus
        pages {
          id
          title
          order
          questions {
            id 
            title 
            description 
            required 
            type 
            scope 
            order
            questionnairePageOrder
            visible
            options { 
              id 
              label 
              order 
              visibility 
              visibilityRules { 
                id 
                sourceQuestionId 
                allowedValues 
              } 
            }
            visibilityRules { 
              id 
              sourceQuestionId 
              allowedValues 
            }
          }
        } 
      }
    }
  }
`;

export {
  GET_EVENT_LIST,
  GET_EVENT,
  SEARCH_LISTINGS,
  GET_CATEGORIES,
  GET_GEOREGIONS,
  GET_MAIN_EVENT_LIST,
  GET_LOCATION_VENUE_EVENTS
};
